import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/element-variables.scss";
import axios from "axios";
import Base64 from "./assets/js/base64.js"; // 用于query传参加密
import common from "./assets/js/common.js"; // 公共js
import utls from "./assets/js/utls.js";
import xss from './assets/js/xss';
// import {
console.log(process.env.NODE_ENV, "????????????");
import messageBox from "./common/messageBox.vue";
//   message
// } from './assets/js/resetMessage';
// import 'lib-flexible'

// import Qs from 'qs'
// 公共js
// import './assets/css/common.css';
// 公共css

// import 'element-ui/lib/theme-chalk/index.css';
// import './element-variables.scss'


import "./assets/css/common.css";
import Resource from "vue-resource";
Vue.prototype.$Base64 = Base64;
Vue.use(common);
Vue.use(Resource); //使用resource
Vue.prototype.xss = xss;
// axios.defaults.baseURL = '/cat';
Vue.use(utls);
Vue.component("messageBox", messageBox);
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.prototype.baseURL = "/cat"; // HTML 中路径的前缀

Vue.prototype.$privatization = process.env.VUE_APP_NAME === "drill" || process.env.VUE_APP_NAME==="shanghai"; // 私有化全局变量


Vue.prototype.$independence = process.env.VUE_APP_INDEPENDENCE === "1"; // 独立版本 - 私有化部署
Vue.prototype.$platformType = Number(process.env.VUE_APP_PLATFORMTYPE);

// 前置守卫
router.beforeEach(async (to, from, next) => {
  //该函数 在路由跳转之后,组件渲染（加载）之前；执行
  document.title = to.meta.til || process.env.VUE_APP_TITLE_NAME;
  console.log(to, "//")
  if (process.env.VUE_APP_HOSPITAL === "demo" && (!localStorage.myPlatformType || to.path === "/login/login_in") && to.query.previewKey) {
    let {
      resultCode,
      result
    } = await Vue.prototype.catReq1Service("/user/getDeployView", {
      key: to.query.previewKey
    })
    if (resultCode === "1" && result) {
      document.title = result.name + "人机合译教学实践平台";
      localStorage.setItem("myPlatformType", result.platformType);
      localStorage.setItem("myAppTitle", result.name);
      localStorage.setItem("myFaviconIcon", result.faviconIcon);
      localStorage.setItem("myLoginLogoPic", result.loginLogoPic);
      localStorage.setItem("myLogoPic", result.logoPic);
      localStorage.setItem("myLoginSloganPic", result.loginSloganPic);
      Vue.prototype.$platformType = result.platformType; // 平台版本编码
    }
  } else if (!localStorage.myPlatformType && process.env.VUE_APP_HOSPITAL === "demo") {
    let {
      resultCode,
      result
    } = await Vue.prototype.catReq1Service("/user/queryPlatformByHost", {
      host: window.location.host
    })
    if (resultCode === "1" && result && result.title) {
      document.title = result.title + "人机合译教学实践平台";
      localStorage.setItem("myPlatformType", result.platformType);
      localStorage.setItem("myAppTitle", result.title);
      if (result.faviconIcon) {
        localStorage.setItem("myFaviconIcon", result.faviconIcon);
      } else {
        localStorage.setItem("myFaviconIcon", "./wy_logo.ico");
      }
      localStorage.setItem("myLoginLogoPic", result.loginLogoPic);
      localStorage.setItem("myLogoPic", result.logoPic);
      localStorage.setItem("myLoginSloganPic", result.loginSloganPic);
      Vue.prototype.$platformType = result.platformType; // 平台版本编码
    }
  } 
  // else if (process.env.VUE_APP_HOSPITAL === "demo" && result && !result.title) {
  //   Vue.prototype.$platformType = Number(localStorage.myPlatformType);
  //   document.title = localStorage.myAppTitle + "人机合译教学实践平台";
  // } 
  else if (process.env.VUE_APP_HOSPITAL === "demo") {
    Vue.prototype.$platformType = Number(localStorage.myPlatformType);
    document.title = localStorage.myAppTitle + "人机合译教学实践平台";
  }
  if (!localStorage.myUser && process.env.VUE_APP_INDEPENDENCE != 1 && to.path !== "/" && to.path !== "/index" && to.path !== "/propaganda" && to.path !== "/help") {
    let response = await Vue.prototype.catReq1Service("/api/v1/user/getUserInfo")
    if (response.resultCode === "1") {
      let data = response.result;
      let val = JSON.stringify(data);
      localStorage.setItem("myUser", val);
      localStorage.setItem("myPhone", data.loginPhone); // 电话
      localStorage.setItem("myUserImg", data.avatar); // 头像
      localStorage.setItem("myUserName", data.nickName); // 昵称
      localStorage.setItem("myAliasName", data.aliasName); // 别名  --
      localStorage.setItem("lastSelectCompany", JSON.stringify(data.lastSelectCompany));
      localStorage.setItem("myCompanyCode", data.lastSelectCompany.code); // 公司编码
      localStorage.setItem("myId", data.lastSelectCompany.id);
    }
  }
  //在不同页面获取新手引导进度显示相应新手引导
  if(to.path == "/home/projectHome/fileList") {
    const response = await Vue.prototype.catReq1Service("/api/v1/user/getUserInfo");
    if (response.resultCode === "1") {
      if(response.result.guideProgress == 0) {  //创建项目
        store.commit("setIsNovice", true);
        store.commit("setNumOfGuide", 0)
      } else if(response.result.guideProgress == 3) { //项目管理
        store.commit("setIsNovice", true);
        store.commit("setNumOfGuide", 3)
      }
    }
  }
  else if(to.path == "/home/projectHome/project/file") {
    const response = await Vue.prototype.catReq1Service("/api/v1/user/getUserInfo");
    if (response.resultCode === "1") {
      if(response.result.guideProgress == 1) {  //上传文件
        store.commit("setIsNovice", true);
        store.commit("setNumOfGuide", 1)
      }
    }
  }
  else if(to.path == "/home/projectHome/project/fileSet") {
    const response = await Vue.prototype.catReq1Service("/api/v1/user/getUserInfo");
    if (response.resultCode === "1") {
      if(response.result.guideProgress == 2) {  //项目名设置
        store.commit("setIsNovice", true);
        store.commit("setNumOfGuide", 2)
      }
    }
  }
  else if(to.path == "/editor") {
    const response = await Vue.prototype.catReq1Service("/api/v1/user/getUserInfo");
    if (response.resultCode === "1") {
      if(response.result.guideProgress == 4) {  //编辑器
        store.commit("setIsNovice", true);
        store.commit("setNumOfGuide", 4)
      }
    }
  }
  //wxAddress
  // if (
  //   !localStorage.myPhone &&
  //   !localStorage.myEmail &&
  //   to.path !== "/" &&
  //   to.path != "/login/relation" &&
  //   to.path !== "/index" &&
  //   to.path !== "/login/login_in" &&
  //   to.path !== "/login/login_register" &&
  //   to.path !== "/login" &&
  //   to.path !== "/login/login_up" &&
  //   to.path !== "/authentication" &&
  //   to.path !== "/help" &&
  //   to.path !== "/login/wxAddress" &&
  //   to.path !== "/propaganda"
  // ) {
  //   router.replace({
  //     name: "relation",
  //     params: {
  //       userId: "123",
  //     },
  //   });
  // } else {
  next();
  // }

  //判断是否需要缓存
  // if (to.path === '/memoryBank') {
  //   to.meta.keepAlive = true;  // 让 列表页 缓存,即不刷新
  //   next();
  // } else {
  //   to.meta.keepAlive = false;  // 让 列表页 即不缓存,刷新
  //   next();
  // }
  // next()
});
// function asa(params) {
//   console.log(params)
//   router.addRoutes(params)
// }

new Vue({
  router,
  store,
  render: (h) => h(App),
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))

  // }
}).$mount("#app");